'use client';
import React, { useEffect, useState } from 'react';
import { getCookie } from 'typescript-cookie';
import RelatedItemsListCarousel from '@/components/customercenter-ui/components/home/relatedItems';
import { COOKIE_KEYS } from '../../../../../constants/constant';
const RelatedItemsListCarouselTastic = (data: any) => {
  const [siteId, setSiteId] = useState<string>();
  const { text, maxRelatedProductsPerPage } = data?.data;

  useEffect(() => {
    const cookieSiteId = getCookie(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
    setSiteId(cookieSiteId);
  }, []);

  return (
    <RelatedItemsListCarousel
      data={data}
      title={text}
      siteId={siteId}
      maxRelatedProductsPerPage={maxRelatedProductsPerPage}
    />
  );
};

export default RelatedItemsListCarouselTastic;
